<template lang="pug">
    v-container#login.fill-height.justify-center(tag="section")
        v-row(justify="center")
            v-col
                v-card.login-card.mx-auto(light="" elevation="12" style="max-width: 550px;" )
                    v-skeleton-loader.mx-auto(v-if="isLoading" ref="skeleton" type="card-avatar")
                    static(v-else)
</template>

<script>
  export default {
    name: 'PagesLogin',
    components: {
      static: () => import('@/views/custom/CMS/Statics'),
    },
    props: {
      openTab: {
        type: Number,
        default: 2,
      },
      inDialog: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        title: 'Terms and Conditions',
        isLoading: false,
      }
    },
    computed: {
      policies () {
        return this.$store.getters['cms/getStatic']
      },
      tab () {
        return `tab-${+this.openTab}`
      },
    },
    mounted () {
      this.goTostatic()
    },
    methods: {
      goTostatic () {
        const vm = this
        vm.isLoading = true
        vm.$store.dispatch('cms/getItem', { context: 'static', id: '-MN-f3gN-nT_eBduHp7o' }).then(function () {
          vm.isLoading = false
        })
      },
    },
  }
</script>

<style lang='scss' scoped>
.terms-wrapper{
  li {
    text-align: justify;
    padding: .25rem 0;
  }
}
.login__logo{
    max-height: 20px;
  }
  .login-card{
    border-radius: 25px !important;
  }
</style>
